import React from 'react';
import classnames from 'classnames';
import { bool, string, node } from 'prop-types';

const List = ({ children, className, dense, ...props }) => (
  <ul
    {...props}
    className={classnames([
      'mdc-list',
      {
        'mdc-list--dense': dense,
      },
      className,
    ])}
  >{children}</ul>
);

List.propTypes = {
  children: node.isRequired,
  className: string,
  dense: bool,
};

List.defaultProps = {
  className: undefined,
  dense: undefined,
};

export default List;
